export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'How do I receive the pack after purchasing?',
    answer:
      'You will receive immediate access to all materials via email and download link. No waiting, no complicated steps. Download everything to your device and start using it right away.',
  },
  {
    question: 'What level of ballet teacher is this for?',
    answer:
      'This system is designed for ballet teachers at all levels—from those just starting out to experienced professionals. The material is organized by student level (beginner through intermediate) and student age (3-16), so you teach exactly what’s right for your students.',
  },
  {
    question: 'Can I edit the material to fit my studio?',
    answer:
      'Yes! The PDFs are fully editable. You can customize names, add your studio logo, adjust combinations to match your teaching style, or adapt anything to fit your specific needs.',
  },
  {
    question: 'Does this work for ballet teachers in any country?',
    answer:
      'Absolutely. The system is designed for teachers worldwide. Teachers in the USA, UK, Canada, Australia, and beyond are already using and loving it.',
  },
  {
    question: 'What currency will I pay in?',
    answer:
      'The price adapts to your local currency automatically at checkout. Whether you’re in USD, GBP, AUD, CAD, or any other currency, you’ll see the fair equivalent of $27.',
  },
  {
    question: 'What if it doesn’t work for me?',
    answer:
      'We offer a complete 7-day money-back guarantee. If the material doesn’t deliver the value we promise, we’ll refund every cent—no questions asked.',
  },
]
